import { render, staticRenderFns } from "./ProceedActionModal.vue?vue&type=template&id=5e2e2a4e"
import script from "./ProceedActionModal.vue?vue&type=script&lang=js"
export * from "./ProceedActionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports